// extracted by mini-css-extract-plugin
export default {"button":"KPILeanSelect_button__8HVFH"};